import { useIsFetching } from 'react-query'

import type { FilterUIState } from 'features/filters/store'
import { useFilterUIStore } from 'features/filters/store'

/**
 * True while the project's default filter-option list
 * (`useFilterUIStore.defaultFilterList`, populated by `useProjectFilterList`'s
 * `filter-list-data` query) is still empty and that query is in flight.
 * Shared by `ChartControlsSidebar` and Feedback's filter sidebar so both
 * surfaces gate their loading skeletons on the same condition.
 *
 * Deliberately checks `length === 0 && activeRequests > 0` rather than
 * `length === 0` alone — a failed query must not pin the skeleton on
 * forever.
 */
export const useDefaultFilterListLoading = (
  projectId: string | undefined,
): boolean => {
  const defaultFilterList = useFilterUIStore(
    (state: FilterUIState) => state.defaultFilterList,
  )
  const activeRequests = useIsFetching(['filter-list-data', projectId])
  return defaultFilterList.length === 0 && activeRequests > 0
}
